export default function(arrayOfRefs, callback) {
    // Create a promise for every field we need to validate
    const promises = arrayOfRefs.map((ref) => {
        return new Promise(resolve => {
            if (!ref.name)
                throw new Error('This ref has no name set');

            ref.$validator.validate(ref.name).then(resolve);
        });
    });

    // Execute all the promises and store their results
    const results = Promise.all(promises);

    // Check if one of the validations failed
    // -if so: call the callback with the 'false' param, to notify that 1 failed
    // -else: call the callback with the 'true' param, to notify that everything passed
    const _callback = callback;
    results.then((data) => {
        const foundFalse = data.some(elem => {
            return !elem;
        });

        if (foundFalse)
            _callback(false);
        else
            _callback(true);
    });
}
